import { render, staticRenderFns } from "./ImportCookiesDialog.vue?vue&type=template&id=ca06fa38&scoped=true"
import script from "./ImportCookiesDialog.vue?vue&type=script&lang=ts"
export * from "./ImportCookiesDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImportCookiesDialog.vue?vue&type=style&index=0&id=ca06fa38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06fa38",
  null
  
)

export default component.exports